export default function useCache(cacheKey, action, params) {

    const { data, error, isFetching } = action(params);
    if(data)
    {
        const cachedData = JSON.stringify(data)
        localStorage.setItem(cacheKey, cachedData);

        return {
            data, 
            error, 
            isFetching,
            cached: false
        };
    }

    return {
        data: JSON.parse(localStorage.getItem(cacheKey)),
        error: false,
        isFetching: false,
        cached: true
    };
}